// extracted by mini-css-extract-plugin
export var tudContainerDesktop = "TrialUpgradeDisclaimer_tudContainerDesktop__kwTS+";
export var tudContainerMobile = "TrialUpgradeDisclaimer_tudContainerMobile__Iu2NL";